import {useTranslation} from "@Translation/hooks/useTranslation";
import {
    singleModalTranslationKey
} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";

interface HowFarContentProps {
    departure: string,
    destination: string,
    distance: string,
}
function HowFarContent({departure, destination, distance}: HowFarContentProps) {
    const title = useTranslation(
        `${singleModalTranslationKey}.how_far.title`,
        {departure, destination}
    )

    const content = useTranslation(
        `${singleModalTranslationKey}.how_far.description`,
        {departure, destination, distanceLand: distance}
    )

    return (
        <TitleAndContent
            title={title}
            content={content}
        />
    )
}

export default HowFarContent